export default Object.freeze({
//    WEB_HOST: 'http://osaka-u.rd.public.s3-website-ap-northeast-1.amazonaws.com',
// 開発時のみ
//    WEB_HOST: 'https://d27dvn5omhsgge.cloudfront.net',
//    WEB_HOST: 'https://rd.iai.osaka-u.ac.jp',
       WEB_HOST: '',
//    QUERY_ENDPOINT: 'https://he87qhem95.execute-api.ap-northeast-1.amazonaws.com/default/rmap-v2-query-for-es'
// 開発時のみ
//  QUERY_ENDPOINT: 'https://d27dvn5omhsgge.cloudfront.net/api/query'
//    QUERY_ENDPOINT: 'https://rd.iai.osaka-u.ac.jp/api/query'
       QUERY_ENDPOINT: '/api/query'
})